import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ExpertProductApi from "../../../api/ExpertProductApi";
import ExpertProductListItem from "../expert/ExpertProductListItem";
import MyExpertChangeInfo from "./MyExpertChangeInfo";
import UserContext from "../../../context/UserContext";

const TABS = [
    { label: "전체", value: "" },
    { label: "판매중", value: "A" },
    { label: "광고중", value: "AD" },
    { label: "승인 대기중", value: "W" },
    { label: "비승인", value: "R" },
];

const filterByTab = (curTab, p) => {
    if (curTab === "") return true;
    if (curTab === "AD") return p.expert_product_type === "EPT02";
    return curTab === p.expert_product_status;
};

const MyExpert = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const [curTab, setCurTab] = useState("");
    const [counts, setCounts] = useState([0, 0, 0, 0, 0]);
    const [products, setProducts] = useState([]);

    const handleAdRequestBtnClick = () => {
        navigate("/expert/adRequest");
    };

    const handleRegisterBtnClick = (expertId = "init") => {
        navigate(`/expert/productWrite/${expertId}`);
    };

    useEffect(() => {
        if (!user?.userId) return;

        ExpertProductApi.getExpertProducts({
            category: "",
            page: 1,
            cnt: 100,
            searchKeyword: "",
            isMine: true,
        })
            .then((rslt) => {
                if (!rslt?.products) return;
                setProducts(rslt.products);
                const newCounts = [rslt.products.length, 0, 0, 0, 0];
                for (const prd of rslt.products) {
                    if (prd.expert_product_status === "A") newCounts[1]++;
                    else if (prd.expert_product_status === "W") newCounts[3]++;
                    else if (prd.expert_product_status === "R") newCounts[4]++;
                    if (prd.expert_product_type === "EPT02") newCounts[2]++;
                }
                setCounts(newCounts);
            })
            .catch((error) => {
                const status = error?.response?.status;
                if (status === 401) {
                    alert("로그인이 만료되었습니다. 다시 로그인해주세요.");
                    sessionStorage.setItem("referrer", window.location.href);
                    navigate("/login");
                }
            });
    }, [user?.userId, navigate]);

    const filteredProducts = products.filter((p) => filterByTab(curTab, p));

    return (
        <>
            {/* <MyExpertChangeInfo /> */}
            <div className="section-area">
                <div className="section-header">
                    <h1 className="section-header-title">전문가 서비스</h1>
                    <div className="section-header-right pc-only">
                        <button
                            type="button"
                            className="btn btn-primary-line"
                            onClick={() => handleRegisterBtnClick()}
                        >
                            <span>서비스 등록</span>
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAdRequestBtnClick}
                        >
                            <span>광고 신청</span>
                        </button>
                    </div>
                </div>

                <div className="section-header">
                    <div className="section-category">
                        <ul>
                            {TABS.map((tab, idx) => (
                                <li
                                    key={tab.value || "all"}
                                    className={curTab === tab.value ? "active" : ""}
                                    onClick={() => setCurTab(tab.value)}
                                >
                                    {tab.label} {counts[idx]}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="section-content">
                    <div className="mypage-bbs-list">
                        <ul className="vertify-list">
                            {filteredProducts.map((product) => (
                                <ExpertProductListItem
                                    key={product.expert_product_id}
                                    product={product}
                                    onUpdate={setProducts}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MyExpert;
